
/**
 * Storage for session balance, orders and current layers.
 */

import React, { useReducer, createContext } from "react";

export const BalanceContext = createContext();

const initialState = {
  balance: 0,
  orders:[],
  dlayer:[]
};


const reducer = (state, action) => {
  switch (action.type) {
    case "add":
      return {
        balance: action.payload.balance,
        orders: [...state.orders, action.payload.orders]
      };
    case "action":
        console.log("Current action:"+action.payload.caction)
        return {
          ...state, 
          caction: action.payload.caction,
        };

    case "end":
        return {
            balance: 0,
            orders:[],
            blayer: 0,
            dlayer:[],
        };
      
    default:
      throw new Error();
  }
};

export const BalanceContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <BalanceContext.Provider value={[state, dispatch]}>
      {props.children}
    </BalanceContext.Provider>
  );
};